// extracted by mini-css-extract-plugin
export default {"mCard":"MB-z","image":"NB-z","imageNoBackground":"OB-z","imageHasCategory":"PB-z","fullWidth":"QB-z"};